import API from "core/api/axios/base";
import UserInfoErrorHandler from "core/api/handler/UserInfoErrorHandler";
import Cookies from "universal-cookie";

export default async function endSession() {
  const cookies = new Cookies();
  let accesstoken = cookies.get("accesstoken");
  let config = {
    params: {
      "clientid": process.env.REACT_APP_PING_CLIENT_ID,
      "token": accesstoken,
    },
    withCredentials: true
  };

  return API.get(`${process.env.REACT_APP_END_SESSION}`, config)
    .then(() => {
      return true;
    })
    .catch((error) => {
      const errorHandler = UserInfoErrorHandler(error);
      const responseError = {
        ...errorHandler,
      };
      return responseError;
    });
}
